var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTool4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.2303,
    cy: 12.3998,
    rx: 9,
    ry: 3.62157,
    transform: "rotate(-15 10.2303 12.3998)",
    fill: "#62A1B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3779 6.38135C13.3316 6.38135 14.1055 7.15523 14.1055 8.10889V12.6978C14.1052 13.3951 13.5392 13.9604 12.8418 13.9604H12.6836L12.1152 19.0825C12.0797 19.4023 11.8091 19.644 11.4873 19.644H8.5127C8.19088 19.644 7.9203 19.4024 7.88477 19.0825L7.31543 13.9604H7.1582C6.46075 13.9604 5.89478 13.3951 5.89453 12.6978V8.10889C5.89453 7.15537 6.66763 6.38158 7.62109 6.38135C7.83403 6.38135 8.04323 6.44069 8.22461 6.55225L8.67578 6.82959C9.48774 7.32925 10.5123 7.32925 11.3242 6.82959L11.7754 6.55225C11.9566 6.44081 12.1652 6.38142 12.3779 6.38135ZM10 1.64502C11.2208 1.64502 12.2109 2.63515 12.2109 3.85596C12.2107 5.07655 11.2207 6.06592 10 6.06592C8.77935 6.06592 7.78932 5.07655 7.78906 3.85596C7.78906 2.63515 8.77919 1.64502 10 1.64502Z",
    fill: "#8CBBC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool4);
export default __webpack_public_path__ + "static/media/tool_4.586f73764ff220ebf996243c3f087693.svg";
export { ForwardRef as ReactComponent };